import { z } from "zod";

/** Shared response schemas for asynchronous tailored-PDF generation. */
export const pdfJobPendingSchema = z.object({
  jobId: z.string().min(1),
  status: z.enum(["queued", "rendering"]),
});

export const pdfJobReadySchema = z.object({
  jobId: z.string().min(1),
  status: z.literal("ready"),
  downloadUrl: z.string().min(1),
});

export const pdfJobFailedSchema = z.object({
  jobId: z.string().min(1),
  status: z.literal("failed"),
  retryable: z.boolean(),
  message: z.string().min(1),
});

export const pdfJobStatusSchema = z.discriminatedUnion("status", [
  pdfJobPendingSchema.extend({ status: z.literal("queued") }),
  pdfJobPendingSchema.extend({ status: z.literal("rendering") }),
  pdfJobReadySchema,
  pdfJobFailedSchema,
]);

export const pdfNotReadySchema = z.object({
  code: z.literal("PDF_NOT_READY"),
  message: z.string().min(1),
});

export type PdfJobPending = z.infer<typeof pdfJobPendingSchema>;
export type PdfJobReady = z.infer<typeof pdfJobReadySchema>;
export type PdfJobFailed = z.infer<typeof pdfJobFailedSchema>;
export type PdfJobStatus = z.infer<typeof pdfJobStatusSchema>;
export type PdfNotReady = z.infer<typeof pdfNotReadySchema>;
